import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
/** Style Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import { Form, Button, ButtonGroup } from "react-bootstrap";
import Loading from "../../Components/Loading";
import AniFormGroup from "./AniFormGroup";
import Dialog from "../../Components/Dialog";
import SearchInput from "../../Components/SearchInput";
import KakaoAddress from "../../Components/Kakao/DaumPostCode";
import Swal from "../../Components/SweetAlert2";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBuilding, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const TOTAL_STEPS = 13;

function SignUp() {
  const navigate = useNavigate();
  const location = useLocation();
  const language = useSelector((state) => state.localStorage.language);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [lastIdChecked, setLastIdChecked] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    id: "",
    idCheck: "",
    password: "",
    passwordConfirm: "",
    passwordCheck: "",
    companyCode: "",
    companyCodeCheck: "",
    companyName: "",
    companyType: "",
    industryCode: "",
    industryName: "",
    email: "",
    phone: "",
    smsSend: "",
    smsCode: "",
    smsCheck: "",
    address: "",
    addressEng: "",
    jibunAddress: "",
    jibunAddressEng: "",
    zoneCode: "",
    birth: "",
    emergencyTel: "",
    nationalityItems: [],
    nationality: "",
    constructionTypeItems: [],
    constructionType: "",
    constructionTypeCode: "",
    genderItems: [],
    gender: "",
    bloodTypeItems: [],
    bloodType: "",
    companyPhone: "",
    companySmsSend: "",
    companySmsCode: "",
    companySmsCheck: "",
    authGroup: "",
  });
  const formGroups = [
    {
      title: "이름",
      type: "text",
      name: "name",
      placeholder: "이름을 입력해주세요.",
      step: 0,
    },
    {
      title: "아이디",
      type: "text",
      name: "id",
      placeholder: "아이디를 입력해주세요.",
      step: 1,
    },
    {
      title: "비밀번호",
      type: "password",
      name: "password",
      placeholder: "비밀번호를 입력해주세요.",
      step: 2,
    },
    {
      title: "비밀번호 확인",
      type: "password",
      name: "passwordConfirm",
      placeholder: "비밀번호를 다시 입력해주세요.",
      step: 3,
    },
    {
      title: "전화번호",
      type: "tel",
      name: "phone",
      placeholder: "숫자만 입력해주세요.",
      step: 4,
    },
    {
      title: "인증번호",
      type: "tel",
      inputMode: "numeric",
      name: "smsCode",
      placeholder: "인증번호를 입력해주세요.",
      step: 5,
    },
    {
      title: "회사명",
      type: "text",
      name: "companyName",
      placeholder: "회사명을 입력해주세요.",
      step: 6,
    },
    {
      title: "사업자 등록번호",
      type: "text",
      name: "companyCode",
      placeholder: "사업자 번호를 입력해주세요. ('-' 제외)",
      step: 7,
    },
    {
      title: "업태·업종",
      type: "text",
      name: "companyType",
      placeholder: "업태·업종을 입력해주세요. (예: 서비스업)",
      step: 8,
    },
    {
      title: "회사 주소",
      type: "text",
      name: "companyAddress",
      placeholder: "회사 주소를 입력해주세요.",
      step: 9,
    },
    {
      title: "대표 담당자 전화번호",
      type: "tel",
      name: "companyPhone",
      placeholder: "대표 담당자 전화번호를 입력해주세요.",
      step: 10,
    },
    {
      title: "대표 담당자 인증번호",
      type: "tel",
      inputMode: "numeric",
      name: "companySmsCode",
      placeholder: "인증번호를 입력해주세요.",
      step: 11,
    },
    {
      title: "이메일",
      type: "text",
      name: "email",
      placeholder: "이메일을 입력해주세요.",
      step: 12,
    },
  ];
  const [smsCode, setSmsCode] = useState("");
  const [companySmsCode, setCompanySmsCode] = useState("");
  const [showDialog1, setShowDialog1] = useState(false);
  const [wording, setWording] = useState({
    signUpDialogTitle: "회원가입 하시겠습니까?",
    signUpDialogConfirmButton: "확인",
    signUpDialogCancelButton: "취소",
    authPhoneMessage1: "세이프웨이-SAFEWAY 인증번호입니다.",
    authPhoneMessage2: "인증번호를 입력해주세요.",
    authPhoneMessage3: "인증번호: ",
    authPhoneMessageTitle: "계정관리",
    completeSignUpMessage1: "회원가입이 완료되었습니다.",
    completeSignUpMessage2: "안전한 하루되세요^^",
    afterSignUpMessage1: "세이프웨이-SAFEWAY 가입을 축하드립니다.",
    afterSignUpMessage2: "관리자 사이트 안내",
    afterSignUpMessage3: "관리자 홈페이지에서 현장 및 교육 설정을 하실 수 있습니다.",
    afterSignUpMessageTitle: "[세이프웨이-SAFEWAY]가입 안내",
    signUpId: "아이디",
    signUpPassword: "비밀번호",
    companyCodeCheckErrorMessage1: "API 키(Service Key)가 설정되지 않았습니다.",
    companyCodeCheckErrorMessage2: "관리자에게 문의해주세요.",
  });
  const [showDialog2, setShowDialog2] = useState(false);
  const [dialogSearchText, setDialogSearchText] = useState("");
  const [industryList, setIndustryList] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedAuthGroup, setSelectedAuthGroup] = useState("");
  const [nameWarning, setNameWarning] = useState("");

  useEffect(() => {
    console.log("location: ", location);
    Init();
  }, []);

  const Init = async () => {
    try {
      GenerateSmsCode();
      const _signUpDialogTitle = await TranslationService.translateText(wording.signUpDialogTitle, language.lang);
      const _signUpDialogConfirmButton = await TranslationService.translateText(wording.signUpDialogConfirmButton, language.lang);
      const _signUpDialogCancelButton = await TranslationService.translateText(wording.signUpDialogCancelButton, language.lang);
      const _authPhoneMessage1 = await TranslationService.translateText(wording.authPhoneMessage1, language.lang);
      const _authPhoneMessage2 = await TranslationService.translateText(wording.authPhoneMessage2, language.lang);
      const _authPhoneMessage3 = await TranslationService.translateText(wording.authPhoneMessage3, language.lang);
      const _authPhoneMessageTitle = await TranslationService.translateText(wording.authPhoneMessageTitle, language.lang);
      const _completeSignUpMessage1 = await TranslationService.translateText(wording.completeSignUpMessage1, language.lang);
      const _completeSignUpMessage2 = await TranslationService.translateText(wording.completeSignUpMessage2, language.lang);
      const _afterSignUpMessage1 = await TranslationService.translateText(wording.afterSignUpMessage1, language.lang);
      const _afterSignUpMessage2 = await TranslationService.translateText(wording.afterSignUpMessage2, language.lang);
      const _afterSignUpMessage3 = await TranslationService.translateText(wording.afterSignUpMessage3, language.lang);
      const _afterSignUpMessageTitle = await TranslationService.translateText(wording.afterSignUpMessageTitle, language.lang);
      const _signUpId = await TranslationService.translateText(wording.signUpId, language.lang);
      const _signUpPassword = await TranslationService.translateText(wording.signUpPassword, language.lang);
      const _companyCodeCheckErrorMessage1 = await TranslationService.translateText(wording.companyCodeCheckErrorMessage1, language.lang);
      const _companyCodeCheckErrorMessage2 = await TranslationService.translateText(wording.companyCodeCheckErrorMessage2, language.lang);
      setWording({
        signUpDialogTitle: _signUpDialogTitle,
        signUpDialogConfirmButton: _signUpDialogConfirmButton,
        signUpDialogCancelButton: _signUpDialogCancelButton,
        authPhoneMessage1: _authPhoneMessage1,
        authPhoneMessage2: _authPhoneMessage2,
        authPhoneMessage3: _authPhoneMessage3,
        authPhoneMessageTitle: _authPhoneMessageTitle,
        completeSignUpMessage1: _completeSignUpMessage1,
        completeSignUpMessage2: _completeSignUpMessage2,
        afterSignUpMessage1: _afterSignUpMessage1,
        afterSignUpMessage2: _afterSignUpMessage2,
        afterSignUpMessage3: _afterSignUpMessage3,
        afterSignUpMessageTitle: _afterSignUpMessageTitle,
        signUpId: _signUpId,
        signUpPassword: _signUpPassword,
        companyCodeCheckErrorMessage1: _companyCodeCheckErrorMessage1,
        companyCodeCheckErrorMessage2: _companyCodeCheckErrorMessage2,
      });
    } catch (e) {
      console.log("Init Error: ", e);
    }
  };

  const Search = async (_param = "") => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Account.getIndustry, {
        keyword: _param,
        size: 5000,
      });
      console.log("Search response: ", response.data);
      if (response.status === 200) {
        if (Array.isArray(response.data.items)) {
          setIndustryList(response.data.items);
        } else {
          setIndustryList([]);
        }
      } else {
        setIndustryList([]);
      }
    } catch (e) {
      setIndustryList([]);
      console.log("Search error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // ID 중복 확인 로직
  const SumitLogic = async (value) => {
    try {
      setLoading(true);
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Account.checkId, { userid: value }).then((result) => {
        let data = result.data;
        console.log("ID 중복 확인 로직: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setFormData((prev) => ({
            ...prev,
            idCheck: true,
          }));
          setLastIdChecked(value);
        }
      });
    } catch (e) {
      console.log("ID 중복 확인 로직 오류: ", e);
      setFormData((prev) => ({
        ...prev,
        idCheck: false,
      }));
    } finally {
      setLoading(false);
    }
  };

  // 공통 SMS 전송 함수
  const sendSMS = async (phoneNumber, authCode, successStateKey, logMessage) => {
    try {
      setLoading(true);
      const params = {
        user_id: process.env.REACT_APP_SMS_API_USER_ID,
        key: process.env.REACT_APP_SMS_API_KEY,
        msg: wording.authPhoneMessage1 + "\n" + wording.authPhoneMessage2 + "\n\n ▶ " + wording.authPhoneMessage3 + authCode,
        receiver: phoneNumber,
        destination: phoneNumber,
        sender: "",
        rdate: "",
        rtime: "",
        testmode_yn: "N",
        title: wording.authPhoneMessageTitle,
        image_path: "",
        companycode: "VBSOMNG-1",
      };

      await Commons.Axios("post", process.env.REACT_APP_SMS_API_URL + Global.urls.Sms.notAuthSendMessage, {}, params).then((result) => {
        let data = result.data;
        console.log(logMessage, data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setFormData((prev) => ({
            ...prev,
            [successStateKey]: true,
          }));
          return true;
        }
      });
      return true;
    } catch (e) {
      console.log(`${logMessage} 오류:`, e);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 회사 인증번호 생성 로직
  const GenerateCompanySmsCode = () => {
    setFormData((prev) => ({
      ...prev,
      companySmsCode: "",
    }));
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    setCompanySmsCode(code);
    return code;
  };

  // 회사 인증번호 전송 로직
  const SendCompanySmsCode = async () => {
    const code = GenerateCompanySmsCode();
    const wasSent = formData.companySmsSend === true;
    const ok = await sendSMS(formData.companyPhone, code, "companySmsSend", "회사 인증번호 전송 로직:");
    if (ok && !wasSent) {
      setActiveStep(11);
    }
  };

  // 인증번호 전송 로직
  const SumitLogic1 = async () => {
    const code = GenerateSmsCode();
    const wasSent = formData.smsSend === true;
    const ok = await sendSMS(formData.phone, code, "smsSend", "인증번호 전송 로직:");
    if (ok && !wasSent) {
      setActiveStep(5);
    }
  };

  // 회원가입 로직
  const SumitLogic2 = async () => {
    try {
      setLoading(true);
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.Account.registerWithCompany,
        {},
        {
          companyCode: formData.companyCode.replace(/-/g, ""),
          companyName: formData.companyName,
          companyType: formData.companyType.replace(/-/g, ""),
          industryCode: formData.industryCode,
          industryName: formData.industryName,
          address: formData.companyAddress,
          addressEng: formData.companyAddressEng,
          jibunAddress: formData.jibunAddress,
          jibunAddressEng: formData.jibunAddressEng,
          zoneCode: formData.zoneCode,
          companyTel: formData.companyPhone,
          userId: formData.id,
          password: formData.password,
          name: formData.name,
          tabletId: "",
          email: formData.email,
          desc: "",
          stat: "Y",
          useYn: "Y",
          tel: formData.phone.replace(/-/g, ""),
          createId: formData.id,
          createDate: new Date().toISOString(),
          updateId: formData.id,
          updateDate: new Date().toISOString(),
          points: 0,
          authGroup: location.state.secret ? formData.authGroup : "BIZ",
        }
      ).then((result) => {
        let data = result.data;
        console.log("회원가입 로직: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          Swal.error(data.message);
        } else {
          Swal.success(wording.completeSignUpMessage1, wording.completeSignUpMessage2);
          SumitLogic3();
          navigate("/login", { state: { type: location.state.type } });
        }
      });
    } catch (e) {
      console.log("회원가입 로직 오류: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 가입 완료 후 문자 전송 로직
  const SumitLogic3 = async () => {
    try {
      setLoading(true);
      const params = {
        user_id: process.env.REACT_APP_SMS_API_USER_ID,
        key: process.env.REACT_APP_SMS_API_KEY,
        msg:
          wording.afterSignUpMessage1 +
          "\n" +
          wording.afterSignUpMessage2 +
          "\n\n ▶ URL: https://admin.safeway.kr \n ▶ " +
          wording.signUpId +
          ": " +
          formData.id +
          " \n ▶ " +
          wording.signUpPassword +
          ": " +
          formData.password +
          "\n\n " +
          wording.afterSignUpMessage3,
        receiver: formData.phone,
        destination: formData.phone,
        sender: "",
        rdate: "",
        rtime: "",
        testmode_yn: "N",
        title: wording.afterSignUpMessageTitle,
        image_path: "",
        companycode: "VBSOMNG-1",
      };
      await Commons.Axios("post", process.env.REACT_APP_SMS_API_URL + Global.urls.Sms.notAuthSendMessage, {}, params).then((result) => {
        let data = result.data;
        console.log("가입 축하 메시지 전송 로직: ", data);
        if (!data) throw new Error(data);
        else if (data.type === "Error") throw new Error(data.message);
      });
    } catch (e) {
      console.log("가입 축하 메시지 전송 로직 오류: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 사업자 등록번호 확인 로직
  const SumitLogic4 = async (value) => {
    try {
      setLoading(true);
      if (location.state.secret) {
        setFormData((prev) => ({
          ...prev,
          companyCodeCheck: true,
        }));
        if (!formData.companyCodeCheck) {
          setActiveStep(8);
        }
        setShowDialog2(true);
        return;
      }
      const cleanCompanyCode = value.replace(/-/g, "");
      const serviceKey = process.env.REACT_APP_DATA_GO_KR_BUSINESS_NUMBER_CHECK_ENCODING_API_KEY;

      if (!serviceKey) {
        Swal.error(wording.companyCodeCheckErrorMessage1, wording.companyCodeCheckErrorMessage2);
        setLoading(false);
        return;
      }

      const response = await axios.post(
        `${Global.urls.External.BusinessCheck}?serviceKey=${serviceKey}`,
        { b_no: [cleanCompanyCode] },
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );
      console.log("사업자등록번호 확인 응답: ", response.data);

      const response1 = await Commons.Axios("get", Global.base.useUrl + Global.urls.Account.checkCompany, {
        companyCode: cleanCompanyCode,
      });
      console.log("사업자등록번호 중복체크: ", response1);

      if (response.data && response.data.data && response.data.data.length > 0 && response1.data) {
        const businessInfo = response.data.data[0];
        const companyChecking = response1.data;
        if (businessInfo.b_stt_cd === "01" && companyChecking) {
          setFormData((prev) => ({ ...prev, companyCodeCheck: true }));
          if (!formData.companyCodeCheck) {
            setActiveStep(8);
          }
          setShowDialog2(true);
        } else {
          setFormData((prev) => ({ ...prev, companyCodeCheck: false }));
        }
      } else {
        setFormData((prev) => ({ ...prev, companyCodeCheck: false }));
      }
    } catch (e) {
      console.log("사업자등록번호 확인 오류: ", e);
      setFormData((prev) => ({ ...prev, companyCodeCheck: false }));
    } finally {
      setLoading(false);
    }
  };

  const FormatCompanyCode = (value) => {
    if (!value) return value;
    const companyCode = value.replace(/[^\d]/g, "");
    const companyCodeLength = companyCode.length;
    if (companyCodeLength < 4) return companyCode;
    if (companyCodeLength < 6) return `${companyCode.slice(0, 3)}-${companyCode.slice(3)}`;
    return `${companyCode.slice(0, 3)}-${companyCode.slice(3, 5)}-${companyCode.slice(5, 10)}`;
  };

  const GenerateSmsCode = () => {
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    console.log("GenerateSmsCode: ", code);
    setSmsCode(code);
    return code;
  };

  const HandleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      if (e.nativeEvent?.isComposing) {
        setFormData((prev) => ({ ...prev, [name]: value }));
        return;
      }
      const sanitized = value.replace(/[^가-힣a-zA-Z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: sanitized }));
      if (sanitized.trim().length >= 2 && nameWarning) setNameWarning("");
      return;
    }
    if (name === "phone" || name === "emergencyTel") {
      const formattedValue = Commons.FormatPhoneNumber(value, formData[name] || "");
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
        smsSend: false,
        smsCheck: "",
      }));
    } else if (name === "id") {
      setFormData((prev) => ({ ...prev, [name]: value, idCheck: "" }));
    } else if (name === "companyCode") {
      if (location.state.secret) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        const formattedValue = FormatCompanyCode(value);
        setFormData((prev) => ({ ...prev, [name]: formattedValue }));
      }
    } else if (name === "companyType" || name === "companyAddress") {
      return;
    } else if (name === "companyPhone") {
      const formattedValue = Commons.FormatPhoneNumber(value, formData[name] || "");
      setFormData((prev) => ({ ...prev, [name]: formattedValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const HandleClick = (e, name) => {
    e.preventDefault();
    if (name === "companyAddress") setShowDialog1(true);
    if (name === "companyType") setShowDialog2(true);
  };

  const HandleReset = (name) => {
    if (name === "phone") {
      setFormData((prev) => ({ ...prev, smsSend: false, smsCheck: "" }));
    } else if (name === "companyPhone") {
      setFormData((prev) => ({ ...prev, companySmsSend: false, companySmsCheck: "" }));
    }
  };

  const HandleReceivePost = (data) => {
    console.log("HandleReceivePost data: ", data);
    setFormData((prev) => ({
      ...prev,
      companyAddress: data.roadAddress,
      companyAddressEng: data.roadAddressEnglish,
      jibunAddress: data.jibunAddress,
      jibunAddressEng: data.jibunAddressEnglish,
      zoneCode: data.zonecode,
    }));
    setShowDialog1(false);
    setActiveStep(10);
  };

  // ─── CTA 버튼 레이블 ────────────────────────────────────────────
  const getCtaLabel = () => {
    switch (activeStep) {
      case 1:
        return formData.idCheck === true ? "다음" : "중복확인";
      case 4:
        return formData.smsSend ? "다음" : "인증번호 전송";
      case 5:
        return formData.smsCheck === true ? "다음" : "인증번호 확인";
      case 7:
        return formData.companyCodeCheck === true ? "다음" : "사업자번호 인증";
      case 8:
        return formData.companyType ? "다음" : "업태·업종 선택";
      case 9:
        return formData.companyAddress ? "다음" : "주소 검색";
      case 10:
        return formData.companySmsSend ? "다음" : "인증번호 전송";
      case 11:
        return formData.companySmsCheck === true ? "다음" : "인증번호 확인";
      case 12:
        return "SAFEWAY 회원가입";
      default:
        return "다음";
    }
  };

  // ─── CTA 버튼 비활성화 여부 ─────────────────────────────────────
  const isCtaDisabled = () => {
    switch (activeStep) {
      case 0:
        return formData.name.replace(/[^가-힣a-zA-Z\s]/g, "").trim().length < 2;
      case 1:
        return !/^[A-Za-z0-9]{5,}$/.test(formData.id);
      case 2:
        return !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(formData.password);
      case 3:
        return !formData.passwordConfirm || formData.passwordConfirm !== formData.password;
      case 4:
        return !/^\d{3}-\d{3,4}-\d{4}$/.test(formData.phone);
      case 5:
        return !formData.smsCode;
      case 6:
        return !formData.companyName.trim();
      case 7:
        if (location.state?.secret) return !formData.companyCode;
        return !/^\d{3}-\d{2}-\d{5}$/.test(formData.companyCode);
      case 8:
        return false;
      case 9:
        return false;
      case 10:
        return !/^\d{3}-\d{3,4}-\d{4}$/.test(formData.companyPhone);
      case 11:
        return !formData.companySmsCode;
      case 12:
        return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
      default:
        return true;
    }
  };

  // ─── 다음 스텝 처리 ──────────────────────────────────────────────
  const handleNextStep = async () => {
    switch (activeStep) {
      case 0: {
        const cleaned = formData.name.replace(/[^가-힣a-zA-Z\s]/g, "");
        if (cleaned.trim().length < 2) {
          setNameWarning("이름은 두 글자 이상 입력해주세요.");
          return;
        }
        setNameWarning("");
        setActiveStep(1);
        break;
      }
      case 1: {
        if (formData.idCheck === true) {
          setActiveStep(2);
          break;
        }
        await SumitLogic(formData.id);
        // SumitLogic 성공 후 idCheck=true 가 되면 다음 탭에서 "다음" 으로 이동 가능
        break;
      }
      case 2: {
        if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(formData.password)) return;
        setActiveStep(3);
        break;
      }
      case 3: {
        if (formData.passwordConfirm !== formData.password) {
          setFormData((prev) => ({ ...prev, passwordCheck: false }));
          return;
        }
        setFormData((prev) => ({ ...prev, passwordCheck: true }));
        setActiveStep(4);
        break;
      }
      case 4: {
        if (formData.smsSend) {
          setActiveStep(5);
          break;
        }
        await SumitLogic1(); // 성공 시 step 5로 자동 이동
        break;
      }
      case 5: {
        if (formData.smsCheck === true) {
          setActiveStep(6);
          break;
        }
        if (formData.smsCode === smsCode) {
          setFormData((prev) => ({ ...prev, smsCheck: true }));
          setActiveStep(6);
        } else {
          setFormData((prev) => ({ ...prev, smsCheck: false }));
        }
        break;
      }
      case 6: {
        if (!formData.companyName.trim()) return;
        setActiveStep(7);
        break;
      }
      case 7: {
        if (formData.companyCodeCheck === true) {
          setActiveStep(8);
          setShowDialog2(true);
          break;
        }
        await SumitLogic4(formData.companyCode); // 성공 시 step 8로 자동 이동 + 업종 다이얼로그 오픈
        break;
      }
      case 8: {
        if (formData.companyType) {
          setActiveStep(9);
        } else {
          setShowDialog2(true);
        }
        break;
      }
      case 9: {
        if (formData.companyAddress) {
          setActiveStep(10);
        } else {
          setShowDialog1(true);
        }
        break;
      }
      case 10: {
        if (formData.companySmsSend) {
          setActiveStep(11);
          break;
        }
        await SendCompanySmsCode(); // 성공 시 step 11로 자동 이동
        break;
      }
      case 11: {
        if (formData.companySmsCheck === true) {
          setActiveStep(12);
          break;
        }
        if (formData.companySmsCode === companySmsCode) {
          setFormData((prev) => ({ ...prev, companySmsCheck: true }));
          setActiveStep(12);
        } else {
          setFormData((prev) => ({ ...prev, companySmsCheck: false }));
        }
        break;
      }
      case 12: {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return;
        if (!formData.id || formData.id !== lastIdChecked) {
          Swal.info("아이디 중복 확인이 필요합니다.");
          return;
        }
        Swal.custom({
          title: wording.signUpDialogTitle,
          icon: "question",
          showConfirmButton: true,
          confirmButtonText: wording.signUpDialogConfirmButton,
          showCancelButton: true,
          cancelButtonText: wording.signUpDialogCancelButton,
        }).then((result) => {
          if (result.isConfirmed) SumitLogic2();
        });
        break;
      }
      default:
        break;
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    } else {
      navigate("/login", { state: { type: location.state?.type } });
    }
  };

  // ─── 현재 스텝의 formGroup ───────────────────────────────────────
  const currentFormGroup = formGroups.find((g) => g.step === activeStep);

  // ─── 스텝별 콘텐츠 렌더링 ────────────────────────────────────────
  const renderStepContent = () => {
    // step 8: 업태·업종 (클릭으로만 선택)
    if (activeStep === 8) {
      return (
        <div className='signup-wizard__dialog-step'>
          <Form.Label className='signup-wizard__field-label'>
            <AutoTranslate targetLanguage={language.lang}>업태·업종</AutoTranslate>
          </Form.Label>
          {formData.companyType ? (
            <div className='signup-wizard__selected-card'>
              <FontAwesomeIcon icon={faBuilding} className='signup-wizard__selected-icon' />
              <span className='signup-wizard__selected-text'>{formData.companyType}</span>
              <button className='signup-wizard__change-btn' onClick={() => setShowDialog2(true)}>
                <AutoTranslate targetLanguage={language.lang}>변경</AutoTranslate>
              </button>
            </div>
          ) : (
            <button className='signup-wizard__picker-btn' onClick={() => setShowDialog2(true)}>
              <FontAwesomeIcon icon={faBuilding} />
              <AutoTranslate targetLanguage={language.lang}>&nbsp;업태·업종 검색하기</AutoTranslate>
            </button>
          )}
        </div>
      );
    }

    // step 9: 회사 주소 (카카오 주소 검색)
    if (activeStep === 9) {
      return (
        <div className='signup-wizard__dialog-step'>
          <Form.Label className='signup-wizard__field-label'>
            <AutoTranslate targetLanguage={language.lang}>회사 주소</AutoTranslate>
          </Form.Label>
          {formData.companyAddress ? (
            <div className='signup-wizard__selected-card'>
              <FontAwesomeIcon icon={faMapMarkerAlt} className='signup-wizard__selected-icon' />
              <span className='signup-wizard__selected-text'>{formData.companyAddress}</span>
              <button className='signup-wizard__change-btn' onClick={() => setShowDialog1(true)}>
                <AutoTranslate targetLanguage={language.lang}>변경</AutoTranslate>
              </button>
            </div>
          ) : (
            <button className='signup-wizard__picker-btn' onClick={() => setShowDialog1(true)}>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <AutoTranslate targetLanguage={language.lang}>&nbsp;주소 검색하기</AutoTranslate>
            </button>
          )}
        </div>
      );
    }

    if (!currentFormGroup) return null;

    // step 4, 5, 10, 11: 인증 관련 — 인라인 버튼 숨기고 CTA로 처리
    const hideActionButton = [4, 5, 10, 11].includes(activeStep);

    return (
      <AniFormGroup
        key={currentFormGroup.name}
        formGroupClassName='signup-wizard__form-group'
        formLabelClassName='signup-wizard__field-label'
        formControlClassName='signup-wizard__field-input'
        activeStep={activeStep}
        {...currentFormGroup}
        value={formData[currentFormGroup.name] ?? ""}
        idCheck={formData.idCheck}
        passwordCheck={formData.passwordCheck}
        smsSend={formData.smsSend}
        smsCheck={formData.smsCheck}
        companyCodeCheck={formData.companyCodeCheck}
        warningText={currentFormGroup.name === "name" ? nameWarning : ""}
        items={[]}
        onChange={HandleInputChange}
        onKeyUp={() => {}}
        onClick={HandleClick}
        onCheck={async (value, name) => {
          if (name === "id") await SumitLogic(value);
          else if (name === "companyCode") await SumitLogic4(value);
        }}
        onTimerComplete={() => {
          setFormData((prev) => ({ ...prev, smsSend: false }));
          setActiveStep(4);
        }}
        companySmsSend={formData.companySmsSend}
        companySmsCheck={formData.companySmsCheck}
        onReset={HandleReset}
        showActionButton={!hideActionButton}
        disableAutoFocus={true}
      />
    );
  };

  return (
    <div className='signup-wizard'>
      {/* ── 헤더 ── */}
      <div className='signup-wizard__header'>
        <button className='signup-wizard__back-btn' onClick={handleBack}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <span className='signup-wizard__title'>
          <AutoTranslate targetLanguage={language.lang}>회원가입</AutoTranslate>
        </span>
        <span className='signup-wizard__step-badge'>
          {activeStep + 1} / {TOTAL_STEPS}
        </span>
      </div>

      {/* ── 진행 바 ── */}
      <div className='signup-wizard__progress-bar'>
        <div className='signup-wizard__progress-fill' style={{ width: `${((activeStep + 1) / TOTAL_STEPS) * 100}%` }} />
      </div>

      {/* ── 콘텐츠 + CTA 영역 ── */}
      <div className='signup-wizard__content'>
        {renderStepContent()}

        {/* step 12: 권한 그룹 선택 (secret 모드) */}
        {activeStep === 12 && location.state?.secret && (
          <div className='signup-wizard__auth-group'>
            <Form.Label className='signup-wizard__field-label'>
              <AutoTranslate targetLanguage={language.lang}>권한 그룹 선택</AutoTranslate>
            </Form.Label>
            <ButtonGroup className='w-100'>
              {["BIZ", "BIZDEV", "BIZSFT"].map((g) => (
                <Button
                  key={g}
                  variant={selectedAuthGroup === g ? "primary" : "outline-primary"}
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, authGroup: g }));
                    setSelectedAuthGroup(g);
                  }}
                >
                  {g}
                </Button>
              ))}
            </ButtonGroup>
          </div>
        )}

        {/* ── CTA 버튼 — 입력칸 바로 아래 ── */}
        <div className='signup-wizard__cta-wrapper'>
          <Button className='signup-wizard__cta-btn' onClick={handleNextStep} disabled={isCtaDisabled()}>
            <AutoTranslate targetLanguage={language.lang}>{getCtaLabel()}</AutoTranslate>
          </Button>
        </div>
      </div>

      {/* ── 다이얼로그 ── */}
      <KakaoAddress show={showDialog1} onHide={() => setShowDialog1(false)} onReceivePost={HandleReceivePost} />
      <Dialog
        show={showDialog2}
        onHide={() => {
          setDialogSearchText("");
          setIndustryList([]);
          setShowDialog2(false);
        }}
        title='업태·업종 선택'
        footer={false}
      >
        {loading && <Loading />}
        <div className='mb-5'>
          <SearchInput isStartIcon isEndXIcon autoFocus placeholder={wording.placeholder1} text={dialogSearchText} setText={(e) => setDialogSearchText(e)} onSumit={() => Search(dialogSearchText)} />
        </div>
        <div className='flex-start-center flex-wrap gap-3 mb-3 px-2' style={{ maxHeight: "50vh", overflowY: "auto" }}>
          {Array.isArray(industryList) && industryList.length < 1 && (
            <div
              className='flex-column-center-center w-100'
              style={{ padding: "40px 20px", textAlign: "center", backgroundColor: "#f8f9fa", borderRadius: "12px", border: "2px dashed #dee2e6", margin: "20px 0" }}
            >
              <div style={{ fontSize: "48px", color: "#6c757d", marginBottom: "16px", opacity: "0.6" }}>🔍</div>
              <p style={{ fontSize: "18px", fontWeight: "600", color: "#495057", margin: "0 0 8px 0" }}>업태·업종을 검색하세요</p>
              <p style={{ fontSize: "14px", color: "#6c757d", margin: "0", lineHeight: "1.5" }}>검색결과가 없는 경우 아무것도 나오지 않습니다</p>
            </div>
          )}
          {Array.isArray(industryList) &&
            industryList.length > 0 &&
            industryList.map((item, index) => (
              <Button
                key={index}
                className={`${selectedIndustry === item.code ? "modern-btn-primary" : "modern-btn-outline-primary"} modern-search-result-btn`}
                size='lg'
                onClick={() => {
                  setSelectedIndustry(item.code);
                  setFormData((prev) => ({
                    ...prev,
                    companyType: item.industry_name,
                    industryCode: item.industry_code,
                    industryName: item.industry_name,
                  }));
                  setDialogSearchText("");
                  setIndustryList([]);
                  setActiveStep(9);
                  setShowDialog2(false);
                }}
              >
                {item.industry_name}
              </Button>
            ))}
        </div>
      </Dialog>
      {loading && <Loading />}
    </div>
  );
}

export default SignUp;
